import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import {
  ReportsList,
} from '../../../_lib/components/ReportsList/ReportsList';
import { ReportsListActionBar } from '../../../_lib/components/ReportsListActionBar/ReportsListActionBar';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SonForm } from '../../../_lib/Form2';
import { ReportItem } from '../../../_lib/components/ReportsList/partials/ReportsListElement';

export type UserImportReportsProps = {
  executeImport: SonForm<any>;
  reports: ReportItem[];
};

export function UserImportReports(props: UserImportReportsProps) {
  const { t } = useSonTranslation('UserImportReports');

  return (
    <>
      <ReportsListActionBar
        form={props.executeImport}
        heading={t('triggerImportExecution')}
        headline={t('interactions.executeImport.form.question')}
        messageSuccess={t('interactions.executeImport.form.messageSuccess')}
        messageSending={t('interactions.executeImport.form.messageSending')}
        messageFail={t('interactions.executeImport.form.messageFail')}
        customErrorTypeMessages={{
          jobAlreadyInProgress: t('interactions.executeImport.form.status.jobAlreadyInProgress'),
          invalidActionInCurrentState: t('interactions.executeImport.form.status.invalidActionInCurrentState'),
        }}
        checkBoxLabel={t('interactions.executeImport.form.checkBoxDryRun')}
      />
      <ReportsList {...props} />
    </>
  );
}

export const UserImportReportsView = asFetchableView(UserImportReports);
export type UserImportReportsView = ComponentProps<typeof UserImportReports>;
